import { units } from '@ui/css';
import { combineTokens, makeScaleableToken, makeSelectors } from '@utils/css';
import { taskBreakpointsCls } from './hook.task-breakpoints.js';
import { wrapper as wrapper$1 } from './molecule.introduction/_introduction.style.js';
import { header, heading } from './molecule.task-header/_task-header.style.js';

const introductionTransitionMs = 275;
combineTokens("--task", {
  paddingInline: [units.px(30), makeScaleableToken]
});
const wrapper = "_35sw1c18w6q";
const contentContainer = "_35sc1kyelak";
const content = "_35sc1sd1dxo";
const introductionWrapper = "_35si19vb985";
const taskSelectors = makeSelectors({
  content,
  header,
  heading,
  introduction: wrapper$1,
  breakpoints: taskBreakpointsCls,
  root: "task--root"
});

export { content, contentContainer, introductionTransitionMs, introductionWrapper, taskSelectors, wrapper };
import "./_task.style.linaria.module.css";
//# sourceMappingURL=_task.style.js.map
